module.exports = __webpack_public_path__ + "img/wsczzhjkyypt6.5f9fb1a1.png";